export const RECEIVE_USER_DOCUMENTS_AND_IMAGES = "RECEIVE_USER_DOCUMENTS_AND_IMAGES";
export const USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER = "USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER";

export interface IDocumentsAndImagesState {
    vaultFileList?: VaultFile[];
    isLoading: boolean;
    totalFileSize: number;
}

export interface VaultFile {
    id?: number;
    label?: string;
    createdDate?: any;
}

export interface GetUserDocumentsAndImagesAction {
    type: "RECEIVE_USER_DOCUMENTS_AND_IMAGES";
    vaultFileList: VaultFile[];
    totalFileSize: number;
}
export interface ShowDocumentsAndImagesLoaderAction {
    type: "USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER";
    isLoading: boolean;
}

export type KnownAction = GetUserDocumentsAndImagesAction | ShowDocumentsAndImagesLoaderAction;
